import API from '../../../../../services/api';
import { headers } from '../helpers/functionalities';

export const API_FACTURAS_DESGUACES = {
    getFacturas: async (page = null, search = null) => {
        const pagination = page !== null ? '?page=' + page : '';
        const searcher = search !== null && page !== null ? '&' + search : search !== null ? '?' + search : '';
        return await API.get('/desguaces' + pagination + searcher).then(res => res.data);
    },
    getFacturaById: async (facturaId) => {
        return await API.get(`/desguaces/${facturaId}/factura`).then(res => res.data);
    },
    generateFacturaPDF: async (idFactura) => {
        return API.get('/desguaces/generate_pdf/' + idFactura).then(res => res.data);
    },
    refund: async (facturaId, factura) => {
        return API.post(`/desguaces/${facturaId}/refund`, factura).then(res => res.data);
    },
    regenerateFactura: async (factura) => {
        return API.post('/desguaces/regenerate', factura).then(res => res.data);
    },
    downloadPlantilla: async () => {
        return API.post('/desguaces/plantilla', {}, {responseType: 'blob'}).then(res => res.data);
    },
    downloadVehiculoInfo: async (vehiculo) => {
        return API.post('/desguaces/vehiculo-info', vehiculo, {responseType: 'blob'}).then(res => res.data);
    },
    generateFacturaAutomatica: async (vehiculo) => {
        return API.post('/desguaces/facturacion-automatica', vehiculo, headers).then(res => res.data);
    },
    generateFacturaManual: async (vehiculo) => {
        return API.post('/desguaces/facturacion-manual', vehiculo, headers).then(res => res.data);
    }
}
